import { render, staticRenderFns } from "./bots-selector.vue?vue&type=template&id=29643fb0&"
import script from "./bots-selector.vue?vue&type=script&lang=js&"
export * from "./bots-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports